module.exports = __webpack_public_path__ + "static/media/sort-alpha-up-alt.91ce3d66.svg";